// 开启vconsole调试
export default function(Vue, options = {}) {
	// 微信浏览器中才使用
	import("vconsole").then(vConsole => new vConsole.default())
}